import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=47e76213&scoped=true&"
import script from "./IssueList.vue?vue&type=script&lang=ts&"
export * from "./IssueList.vue?vue&type=script&lang=ts&"
import style0 from "./IssueList.vue?vue&type=style&index=0&id=47e76213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e76213",
  null
  
)

export default component.exports